import React, { Component, useEffect, useState } from "react";
import { collection, getDocs, getFirestore } from "firebase/firestore/lite";
import { app } from "../firebase";
import Signup from "./Signup";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button } from "react-bootstrap";
import { AuthProvider } from "../contexts/AuthContext";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Dashboard from "./Dashboard";
import Login from "./Login";
import "./style/App.css";
import MerchantSideBar from "./elements/MerchantSideBar";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Profile from "./Profile";
import Rating from "./Rating";
import { useAuth } from "../contexts/AuthContext";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import AdminMerchant from "./AdminMerchant";
import AdminUser from "./AdminUser";
import AdminSideBar from "./elements/AdminSideBar";
import LandingPage from "./LandingPage";
import TopNavbar from "./elements/TopNavbar";
import PrivacyPolicy from "./PrivacyPolicy";

function App() {
  const [showAuth, setShowAuth] = useState(false);
  // disable the developer tools
  document.addEventListener("contextmenu", function (e) {
    e.preventDefault();
    setShowAuth(true);
  });
  useEffect(() => {
    const handleKeyDown = (e) => {
      // if (e.which === 123 || ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.keyCode === 73 || e.keyCode === 105))) {
      //   e.preventDefault();
      //   setShowAuth(true);
      // }
      if (e.which === 123 ) {
        e.preventDefault();
        setShowAuth(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    // Cleanup: remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  const handleClose = () => setShowAuth(false);

  return (
    <BrowserRouter>
      <AuthProvider>
        <Modal show={showAuth} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Copyright Notice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>This website is protected by copyright.</p>
            <p>
              Any unauthorized use or reproduction of content is prohibited.
            </p>
            {/* You can customize this message */}
          </Modal.Body>
          <Modal.Footer>
            <Button id="custom-button" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        <Routes>
          <Route
            exact
            path="/admin/*"
            element={<AdminDashboardWithSidebar />}
          />
          <Route exact path="/*" element={<DashboardWithSidebar />} />
          <Route exact path="/" element={<LandingWithSidebar />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

function PrivateRoute({ path, element: Element }) {
  const { currentUser } = useAuth();
  return currentUser ? <Element /> : <Navigate to="/login" replace />;
}

function PrivateRouteAdmin({ path, element: Element }) {
  const { currentAdmin } = useAuth();
  console.log(currentAdmin);
  return currentAdmin ? <Element /> : <Navigate to="/admin/login" replace />;
}

function DashboardWithSidebar() {
  return (
    <div className="row">
      <div className="col-auto col-sm-3 left-bar ">
        <MerchantSideBar />
      </div>
      <div className="col-8 col-sm-9 p-0" style={{ overflowX: 'scroll' }}>
        <Routes>
          <Route path="/*" element={<Navigate to="/login" replace />} />
          <Route
            path="/dashboard"
            element={<PrivateRoute path="/dashboard" element={Dashboard} />}
          />
          <Route
            path="/rating"
            element={<PrivateRoute path="/rating" element={Rating} />}
          />
          <Route
            path="/profile"
            element={<PrivateRoute path="/profile" element={Profile} />}
          />
        </Routes>
      </div>
    </div>
  );
}

function AdminDashboardWithSidebar() {
  console.log("Admin Sidebar");
  return (
    <div className="row">
      <div className="col-auto col-sm-3 left-bar ">
        <AdminSideBar />
      </div>
      <div className="col-8 col-sm-9 p-0 " style={{ overflowX: 'scroll' }}>
        <Routes>
          <Route path="/*" element={<Navigate to="/admin/login" replace />} />
          <Route
            path="/dashboard"
            element={<PrivateRouteAdmin element={AdminDashboard} />}
            // element={<AdminDashboard/>}
          />
          <Route
            path="/merchant"
            element={<PrivateRouteAdmin element={AdminMerchant} />}
          />
          <Route
            path="/user"
            element={<PrivateRouteAdmin element={AdminUser} />}
          />
        </Routes>
      </div>
    </div>
  );
}

function LandingWithSidebar() {
  console.log("Landing Sidebar");
  return (
    <div >
      <TopNavbar/>
      <LandingPage/>
      <div>
        <Routes>
          <Route path="/" element={<Navigate to="/" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
        </Routes>
      </div>
    </div>
  );
}
export default App;
